<script lang="ts" setup>
import SkrHeading from '@/components/SkrHeading.vue'
import BigPrimaryButton from '@/components/BigPrimaryButton.vue'
import Lottie from '@/components/Lottie.vue'

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
const { mdAndDown, lgAndUp } = useDisplay()
const { track, setSignupContext } = useAnalytics()

const goToSignupNas = async () => {
  setSignupContext({ source: 'nas-conversion', plan: 'starter' })
  track(ANALYTICS_EVENTS.SIGNUP_STARTED)

  await navigateTo({ name: 'signup-starter' })
  emit('close')
}
</script>

<template>
  <div class="upgrade | d-flex flex-column align-center py-8 px-11 justify-space-between">
    <div v-if="lgAndUp">
      <lottie animation="signature" height="200" width="190" class="upgrade__animation" />
      <v-icon size="100" class="upgrade__icon" color="black">custom:dots</v-icon>
    </div>
    <div class="w-100" :class="mdAndDown ? 'mb-7' : 'mb-10'">
      <skr-heading
        level="1"
        class="upgrade__content__title mb-0"
        :class="mdAndDown ? 'pb-1' : 'pb-7'"
        data-cy="overlay_title"
      >
        {{ t('sign.success.upgrade.title') }}</skr-heading
      >
      <p class="upgrade__content__subtitle">{{ t('sign.success.upgrade.subtitle') }}</p>
    </div>
    <div class="upgrade__content w-100" :class="mdAndDown ? 'mt-0' : 'mt-10'">
      <skr-heading level="2" class="upgrade__content__note font-weight-bold mb-0">
        {{ t('sign.success.upgrade.note_1') }}
      </skr-heading>
      <skr-heading level="2" class="upgrade__content__note mb-0">
        {{ t('sign.success.upgrade.note_2') }}
      </skr-heading>
    </div>
    <big-primary-button
      data-cy="upgrade_to_starter_plan_button"
      class="w-100 d-flex"
      :class="mdAndDown ? 'mt-7' : 'mt-15'"
      color="purple-dark"
      color-hover="purple-light-2"
      @click="goToSignupNas"
    >
      <span class="justify-space-between d-flex align-center w-100">
        <h2 class="upgrade__button">{{ t('sign.success.upgrade.cta') }}</h2>
        <v-icon :size="mdAndDown ? 28 : 53">custom:arrow_long</v-icon>
      </span>
    </big-primary-button>
  </div>
</template>

<style lang="scss" scoped>
.upgrade {
  border-radius: 46px;
  background-color: rgba(238, 231, 255, 0.4);
  position: relative;
  @include min-width(lg) {
    padding: 12 * $bw 15 * $bw;
  }
  &__content {
    color: $c-black;
    &__title {
      font-size: $h1-font-size-mobile;
      color: $c-black;
    }
    &__subtitle {
      font-size: 1.125rem;
      color: $c-black;
      @include min-width(md) {
        font-size: 1.5rem;
      }
    }
    &__note {
      @include max-width(sm) {
        font-size: 1rem;
      }
    }
  }

  &__button {
    font-size: 1rem;
  }

  &__icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(40%, 10%);
  }

  &__animation {
    position: relative;
    left: -110%;
    max-width: 190px;
  }
}
</style>
